
























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseMailSkin from '@/components/administration/mailSkin/edit/EditBaseMailSkin.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloMailSkin } from '@/models/alo/AloMailSkin'
import { AloMailSkin } from '@/models/alo/AloMailSkin'

@Component({
  name: 'EditConfig',    
  components:{EditBaseMailSkin}
})
export default class EditConfig extends Vue {
    
  private mailSkin:AloMailSkin = getDefaultAloMailSkin()
  private showDate = false
  private curLang = "fr"

  get tradByLang(){    
    return toStringDictionary(this.mailSkin.lgs,it => it.lg)
  }

  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit(item:AloMailSkin,lang = 'fr') {    
    this.mailSkin = (this.$refs.baseEdit as EditBaseMailSkin).edit(item,true)
    this.curLang = lang
  }
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }        
}
